<template>
	<UiDialog v-if="show">
		<UiElement :settings="dialog.appearance.body.settings">
			<div class="d-flex flex-column align-items-center justify-content-between h-100">
				<div>
					<UiText :settings="heading1" class="text-center" :content="translations?.summaryUpsellTitle || '{summaryUpsellTitle}'" />

					<div style="max-height: 570px; overflow-x: auto;">
						<div v-for="(product, index) in productsList" :key="`product-${index}`" class="w-100">
							<hr v-if="index === 0" class="border-3" style="color: #fff; opacity: 1;" />

							<div class="d-flex align-items-center">
								<div class="d-flex flex-row justify-content-between align-items-start flex-grow-1 pe-4">
									<UiText :settings="heading2" :content="product.label" />

									<UiText
										:settings="heading2"
										class="ps-3"
										:content="`${
									formatNumberWithSpaces(
										smartNumberFormat(
											Number(product.price * (cart.find((item) => item.id === product.id)?.amount || 1)).toFixed(2)
										)
									)
								}&nbsp;${currency}`"
									/>
								</div>

								<UiButtonAmount ref="amountRef" :product="{
							label: product.label,
							id: product.id,
							price: Number(product.price).toFixed(2),
							details: product
						}" :settings="buttonAmount1">
									<template #default="{ count }">
										<UiText :settings="textAmount2" style="color: #fff" :content="count" />
									</template>
								</UiButtonAmount>
							</div>

							<hr class="border-3" style="color: #fff; opacity: 1;" />
						</div>
					</div>
				</div>

				<UiButton
					:settings="button1"
					@touchstart="emit('close')"
					:content="translations?.proceed || '{proceed}'"
				/>
			</div>
		</UiElement>
	</UiDialog>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue';
import { storeToRefs } from 'pinia';

import { useInheritedSettings } from '@/composables/useInheritedSettings';

import { useOrderStore } from '@/stores/useOrderStore';
import { useThemeStore } from '@/stores/useThemeStore';
import { useTranslationsStore } from '@/stores/useTranslationsStore';

import UiText from '@/components/UI/UiText.vue';
import UiDialog from '@/components/UI/UiDialog.vue';
import UiButton from '@/components/UI/UiButton.vue';
import UiElement from '@/components/UI/UiElement.vue';
import UiButtonAmount from '@/components/UI/UiButtonAmount.vue';
import { useKioskStore } from '@/stores/useKioskStore';
import { useDataUtils } from '@/composables/useDataUtils';

const orderStore = useOrderStore();
const { cart } = storeToRefs(orderStore);

const { formatNumberWithSpaces, smartNumberFormat } = useDataUtils();

const emit = defineEmits(['close']);

const props = defineProps({
	show: {
		type: Boolean,
		default: false,
	},
	products: {
		type: Array,
		default: () => [
			{ name: 'Test upsel product 1', id: 0, price: 100 },
			{ name: 'Test upsel product 2', id: 1, price: 50 }
		]
	}
});

const themeStore = useThemeStore();
const kioskStore = useKioskStore();
const translationsStore = useTranslationsStore();

const { theme } = storeToRefs(themeStore);
const { currency, locale } = storeToRefs(kioskStore);
const { translations } = storeToRefs(translationsStore);

const dialog = computed(() => theme.value.pages.dialogSummary);


const productsList = computed(() => {
	return props.products.map((item) => {
		const label = item?.names?.[locale.value]
			|| (locale.value === 'cs' && item?.names?.cz)
			|| item?.names?.en
			|| item?.name
			|| 'Test upsel product';

		return {
			label,
			...item,
		}
	});
});

const heading1 = useInheritedSettings(computed(() => dialog.value?.elements.heading1));
const heading2 = useInheritedSettings(computed(() => dialog.value?.elements.heading2));
const button1 = useInheritedSettings(computed(() => dialog.value?.elements.button1));
const buttonAmount1 = useInheritedSettings(computed(() => dialog.value?.elements.buttonAmount1));
const textAmount2 = useInheritedSettings(computed(() => dialog.value?.elements.textAmount2));
</script>